import { depthToAmbient } from "../physics/pressure.js";
import type { GasMix } from "../types.js";

const OTU_EXPONENT = 5 / 6;

export function otuAtConstantPO2(po2: number, durationMin: number): number {
  if (po2 <= 0.5 || durationMin <= 0) return 0;
  return durationMin * Math.pow((po2 - 0.5) / 0.5, OTU_EXPONENT);
}

export function otuLinearSegment(
  startDepth: number,
  endDepth: number,
  durationMin: number,
  gas: GasMix,
): number {
  if (durationMin <= 0) return 0;
  const STEP = 0.1;
  let total = 0;
  let t = 0;
  while (t < durationMin) {
    const dt = Math.min(STEP, durationMin - t);
    const frac = (t + dt / 2) / durationMin;
    const depth = startDepth + (endDepth - startDepth) * frac;
    const po2 = depthToAmbient(depth) * gas.fO2;
    total += otuAtConstantPO2(po2, dt);
    t += dt;
  }
  return total;
}
